import React, {useContext, useState} from 'react';
import {
  ColorValue, FlexAlignType, Image, Linking, Modal, Platform,
  Pressable, StyleProp, Text, TouchableOpacity, View, ViewStyle
} from 'react-native';
import {DimensionValue} from "react-native/Libraries/StyleSheet/StyleSheetTypes";
import {StoreContext} from '../components/StoreContextProvider';
import {Landing} from '../constants';
import {useNavigation} from '@react-navigation/native';
import {colors} from "../assets/styles/colors";
import TutorialModal from "./TutorialModal";
import {Ionicons} from '@expo/vector-icons';
import MainStyle from "../../MainStyle";
import circleClose from '../assets/img/circle-close-icon.png';
import button_menu from "../assets/img/icons/button_menu.png";
import Div from "../lib/Div";
import P from "../lib/P";

const support_url = 'https://smgames.atlassian.net/servicedesk/customer/portal/3';

type Props = {
  page?: 'splash' | 'support_guide' | 'header' | 'bottom_nav', size?: number, mx?: DimensionValue,
  position?: ViewStyle['position'], top?: DimensionValue, right?: DimensionValue, bw?: number,
  borderColor?: ColorValue, bg?: ColorValue, w?: DimensionValue, h?: DimensionValue, br?: number,
  alignItems?: FlexAlignType,
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly'
};

const HelpLinkModalTrigger = (props: Props) => {
  const {page, size, mx, position, top, right, bw, borderColor, bg, w, h, br, alignItems, justifyContent} = props;
  const navigation: any = useNavigation();
  const Context = useContext(StoreContext);
  const {user, session} = Context;
  const [showTutorial, setShowTutorial] = useState(false);
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);
  const UN_AUTHENTICATIONS_LINKS = [
    {
      title: 'Contact Support',
      onPress: () => {
        if (Platform.OS === 'web') window.open(support_url, '_blank');
        else Linking.openURL(support_url).then();
        setIsHelpModalVisible(false);
      }
    },
    {
      title: 'Tutorial',
      onPress: () => {
        setIsHelpModalVisible(false);
        setShowTutorial(true);
      }
    },
    {
      title: 'Terms and Conditions',
      onPress: () => {
        navigation.navigate('TermsAndConditions');
        setIsHelpModalVisible(false);
      }
    },
    {
      title: 'Privacy Policy',
      onPress: () => {
        setIsHelpModalVisible(false);
        navigation.navigate('PrivacyPolicy');
      }
    },
    {
      title: 'PROMOTIONS TERMS AND CONDITIONS',
      onPress: () => {
        setIsHelpModalVisible(false);
        navigation.navigate('Promotions');
      }
    },
    {
      title: 'About the Company',
      onPress: () => {
        if (Platform.OS === 'web') window.open(Landing, '_self');
        setIsHelpModalVisible(false);
      }
    }
  ];
  const AUTHENTICATIONS_LINKS = [
    {
      title: 'CONTACT SUPPORT',
      onPress: () => {
        if (Platform.OS === 'web') window.open(support_url, '_blank');
        else Linking.openURL(support_url).then();
        setIsHelpModalVisible(false);
      }
    },
    {
      title: 'TRANSACTION HISTORY',
      onPress: () => {
        navigation.navigate('TransactionHistory');
        setIsHelpModalVisible(false);
      }
    },
    {
      title: 'Tutorial',
      onPress: () => {
        setIsHelpModalVisible(false);
        setShowTutorial(true);
      }
    },
    {
      title: 'Notifications',
      onPress: () => {
        navigation.navigate('Notifications');
        setIsHelpModalVisible(false);
      }
    },
    {
      title: 'Terms and Conditions',
      onPress: () => {
        navigation.navigate('TermsAndConditions');
        setIsHelpModalVisible(false);
      }
    },
    {
      title: 'Privacy Policy',
      onPress: () => {
        setIsHelpModalVisible(false);
        navigation.navigate('PrivacyPolicy');
      }
    },
    {
      title: 'Responsible Gaming',
      onPress: () => {
        navigation.navigate('ResponsibleGaming');
        setIsHelpModalVisible(false);
      }
    },
    {
      title: 'Self-Limitation',
      onPress: () => {
        navigation.navigate('SelfExclusion');
        setIsHelpModalVisible(false);
      },
    },
    {
      title: 'PROMOTIONS TERMS AND CONDITIONS',
      onPress: () => {
        setIsHelpModalVisible(false);
        navigation.navigate('Promotions');
      }
    },
    {
      title: 'About the Company',
      onPress: () => {
        if (Platform.OS === 'web') window.open(Landing, '_self');
        setIsHelpModalVisible(false);
      }
    }
  ];

  const style: StyleProp<ViewStyle> = {
    marginHorizontal: mx, position, top, right, borderWidth: bw, borderColor, backgroundColor: bg, width: w, height: h,
    borderRadius: br, alignItems, justifyContent, zIndex: 10
  };

  return (
    <>
      {page === 'bottom_nav' ? (
        <Pressable onPress={() => setIsHelpModalVisible(true)} style={styles.item}>
          <View style={styles.btn}>
            <Ionicons name="settings-outline" size={size || 20} color={colors.white}/>
          </View>
          <Text style={styles.text}>SETTINGS</Text>
        </Pressable>
      ) : (
        <TouchableOpacity onPress={() => setIsHelpModalVisible(true)} style={style}>
          {page === 'splash' ? (
            <Ionicons name="menu" size={size || 20} color="white"/>
          ) : page === 'support_guide' ? (
            <Image source={button_menu} style={{width: size || 20, height: size || 20}}/>
          ) : page === 'header' ? (
            <Ionicons name="settings-outline" size={size || 20} color={colors.white}/>
          ) : (
            <Ionicons name={session ? 'settings-outline' : 'help-circle-outline'} size={size || 20} color="white"/>
          )}
        </TouchableOpacity>
      )}

      <Modal animationType="fade" transparent visible={isHelpModalVisible} statusBarTranslucent={false}
             hardwareAccelerated={false} onRequestClose={() => setIsHelpModalVisible(false)}>
        <Div flex={1} justifyContent="center" alignItems="center" bg={colors.popupDropBg}>
          <Div bg={colors.new_input_color} borderWidth={2} borderColor={colors.popupBorder} rounded={4} p={10}
               position="relative">
            <Div position="absolute" top={-28} right={-28}>
              <TouchableOpacity onPress={() => setIsHelpModalVisible(false)}>
                <Image source={circleClose} style={[MainStyle.h_28, MainStyle.w_28]}/>
              </TouchableOpacity>
            </Div>

            {(!!user ? AUTHENTICATIONS_LINKS : UN_AUTHENTICATIONS_LINKS).map(item => (
              <TouchableOpacity onPress={item.onPress} key={item.title}>
                <P fw="700" lh={36} tt="uppercase" color={colors.whiteText} ta="center">{item.title}</P>
              </TouchableOpacity>
            ))}
          </Div>
        </Div>
      </Modal>

      <TutorialModal visible={showTutorial} onResume={() => setShowTutorial(false)} logged={!!user}/>
    </>
  );
};

const styles = {
  btn: [
    MainStyle.w_48, MainStyle.h_48, MainStyle.b_r_40, MainStyle.bg_settings, MainStyle.a_i_c, MainStyle.j_c_c,
    MainStyle.b_c_settings_border, MainStyle.b_w_1, MainStyle.relative
  ],
  text: [MainStyle.c_white, MainStyle.Barlow500, MainStyle.f_s_12, MainStyle.t_t_u],
  item: [MainStyle.a_i_c, MainStyle.j_c_c, MainStyle.m_x_6]
};

export default React.memo(HelpLinkModalTrigger);
